window.addEventListener('load', () => {
    if (typeof Swiper !== 'undefined') {
        class AnnouncementBarSwiper extends HTMLElement {
            connectedCallback() {
                const swiperContainer = this.querySelector('.swiper');
                if (!swiperContainer) return;
                const slideCount = swiperContainer.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
                const shouldLoop = slideCount > 1;

                // Get settings from data attributes
                const autoplay = this.getAttribute('data-autoplay') === 'true';
                const autoplaySpeed = parseInt(this.getAttribute('data-autoplay-speed')) || 5000;
                const showArrows = this.getAttribute('data-show-arrows') === 'true';
                const showDots = this.getAttribute('data-show-dots') === 'true';

                new Swiper(swiperContainer, {
                    slidesPerView: 1,
                    loop: shouldLoop,
                    speed: 1000,
                    grabCursor: true,
                    allowTouchMove: true,
                    simulateTouch: true,
                    resistance: true,
                    resistanceRatio: 0.85,
                    autoplay: autoplay ? {
                        delay: autoplaySpeed,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true
                    } : false,
                    navigation: showArrows ? {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    } : false,
                    pagination: showDots ? {
                        el: '.swiper-pagination',
                        clickable: true,
                    } : false
                });
            }
        }

        customElements.define('announcement-bar-swiper', AnnouncementBarSwiper);
    }
});